// extracted by mini-css-extract-plugin
export default {"faqStyles":"Faq_faqStyles__-XUVJ","faqList":"Faq_faqList__lw9Ao"};